import Vue from "vue";
import Vuex from "vuex";
import route from "../router/index";
import axiosauth from "../axios-auth"; 
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    snack: "",
    user: null,
    invalidPassword: false,
    autor: {
      nombres: "",
      apellidos: "",
      ingreso: "",
      tipo: ""
    }
  },
  mutations: {
    setSnack(state, snack) {
      state.snack = snack;
    },
    authUser(state, userData) {
      state.user = userData;
      state.invalidPassword = false;
    },
    storeUser(state, user) {
      state.user = user;
    },
    storeAutor(state, autor) {
      state.autor = autor;
    },
    logout(state) {
      state.user = null;
      state.invalidPassword = null;
    },
    invalidPassword(state) {
      state.invalidPassword = true;
    }
  },
  actions: {
    showSnack({ commit }, text) {
      commit("setSnack", text);
      setTimeout(() => {
        commit("setSnack", "");
      }, 10000);
    },
    login({ commit, dispatch }, authData) {

      if (authData.username == 'demo') {
        axios.defaults.baseURL = `${process.env.VUE_APP_URL_API}/public/demo/api`
        axiosauth.defaults.baseURL = `${process.env.VUE_APP_URL_API}/public/demo/api`;
      } else {
        axiosauth.defaults.baseURL = process.env.VUE_APP_URL_API;
        axios.defaults.baseURL = `${process.env.VUE_APP_URL_API}/api`
      }

      axiosauth
        .post("/login?domain=miapa", authData)
        .then(response => {
          commit("authUser", response.data);
          localStorage.setItem("user", JSON.stringify(response.data));
          route.push("/");
          dispatch("getDatosSocio");
        })
        .catch(error => {
          commit("invalidPassword");
          console.log(error);
        });
    },
    getDatosSocio({ commit }) {
      axios
        .get("/miapa/miusuario")
        .then(response => {
          console.log("#########",JSON.stringify(response.data));
          if (response.data && response.data.autor) {
            let autor = {
              nombres: response.data.autor.nombres,
              apellidos: response.data.autor.apellidos,
              ingreso: response.data.autor.fechaIngreso,
              tipo: response.data.autor.tipo,
              ipName: response.data.autor.ipName
            };
            localStorage.setItem("autor", JSON.stringify(autor));
            commit("storeAutor", autor);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    tryAutoLogin({ commit }) {
      const user = localStorage.getItem("user");
      const autor = localStorage.getItem("autor");

      if (user && JSON.parse(user).expirationDate > new Date().getTime()) {
        if (autor) {
          commit("storeAutor", JSON.parse(autor));
        }
        commit("authUser", JSON.parse(user));
      }
    },
    logout({ commit }) {
      commit("logout");
      localStorage.removeItem("user");
      localStorage.removeItem("autor");
      console.log("route", route);
      if (route.history.current.fullPath != "/login") {
        route.push("/login");
      }
    },
    setSocio({ commit }, socio) {
      commit("storeSocio", socio);
    }
  },
  modules: {},
  getters: {
    snack(state) {
      return state.snack;
    },
    user(state) {
      return state.user;
    },
    invalidPassword(state) {
      return state.invalidPassword;
    },
    autor(state) {
      return state.autor;
    }
  }
});
